// extracted by mini-css-extract-plugin
module.exports = {"content":"HomePageStyle_content__1JJR3","backdrop":"HomePageStyle_backdrop__3qtD6","service_article":"HomePageStyle_service_article__2SipK"};